import { takeLatest } from 'redux-saga/effects';
import {
	getPurchaseOrderListSuccess,
	getPurchaseOrderListFail,
	getPurchaseOrderDetailsSuccess,
	getPurchaseOrderDetailsFail,
} from './purchaseOrderState';

import createCrudService from '../../services/crudservice';

import {
	doCrudCall,
	SAVING_MSG,
	UPDATING_MSG,
	DELETING_MSG,
	LOADING_MSG,
	createRecordSuccess,
	updateRecordSuccess,
	deleteRecordSuccess,
} from '../../utils/crudSagaHelper';

const crudService = createCrudService('api/v1/system/purchase-orders');

const redirectData = {
	route: '/console/purchase-orders',
	mode: 'list',
	recordId: 0,
};

const modelName = 'Purchase Order';
const modelId = 'por_id';

function* getPurchaseOrderList(data) {
	yield doCrudCall(
		() => crudService.getList(data.payload),
		getPurchaseOrderListSuccess,
		getPurchaseOrderListFail,
		null,
		null,
		LOADING_MSG
	);
}

function* getPurchaseOrderDetails(data) {
	yield doCrudCall(
		() => crudService.getDetails(data.payload),
		getPurchaseOrderDetailsSuccess,
		getPurchaseOrderDetailsFail,
		null,
		null,
		LOADING_MSG
	);
}

function* doPurchaseOrderCreate(data) {
	yield doCrudCall(
		() => crudService.doCreate(data.payload),
		getPurchaseOrderDetailsSuccess,
		getPurchaseOrderDetailsFail,
		createRecordSuccess(modelName),
		{...redirectData, mode: 'reload'},
		SAVING_MSG
	);
}

function* doPurchaseOrderUpdate(data) {
	const reloadActions = [
		"for_delivery",
		"received",
		"for_invoice",
		"invoice_sent",
		"invoice_paid",
	];

	const redirect =
		reloadActions.includes(data.payload.action)
			? { ...redirectData, mode: "reload" }
			: redirectData;

	yield doCrudCall(
		() =>
			crudService.doUpdate(
				data.payload.por_id,
				data.payload
			),
		getPurchaseOrderDetailsSuccess,
		getPurchaseOrderDetailsFail,
		updateRecordSuccess(modelName),
		redirect,
		UPDATING_MSG
	);
}

function* doPurchaseOrderDelete(data) {
	yield doCrudCall(
		() => crudService.doDelete(data.payload.recordId),
		getPurchaseOrderDetailsSuccess,
		getPurchaseOrderDetailsFail,
		deleteRecordSuccess(modelName),
		{...redirectData,mode: data.payload.mode,},
		DELETING_MSG);
}

function* purchaseOrderSaga() {
	yield takeLatest('purchaseOrder/getPurchaseOrderList',getPurchaseOrderList);
	yield takeLatest('purchaseOrder/getPurchaseOrderDetails',getPurchaseOrderDetails);
	yield takeLatest('purchaseOrder/doPurchaseOrderCreate',doPurchaseOrderCreate);
	yield takeLatest('purchaseOrder/doPurchaseOrderUpdate',doPurchaseOrderUpdate);
	yield takeLatest('purchaseOrder/doPurchaseOrderDelete',doPurchaseOrderDelete);

}

export default purchaseOrderSaga;
